import { render, staticRenderFns } from "./UnauthorisedMedianCutResolution.vue?vue&type=template&id=03a99169"
import script from "./UnauthorisedMedianCutResolution.vue?vue&type=script&lang=js"
export * from "./UnauthorisedMedianCutResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports